import { NgModule } from '@angular/core';
import { SliderComponent } from './slider.component';
import { CommonModule } from '@angular/common';
import { SliderDirection } from './slider-direction';
import { EdAssistUIButtonModule } from '@edassist-ui/button';
import { EdAssistUIIconModule } from '@edassist-ui/icon';
import { EdAssistUIHeadingModule } from '@edassist-ui/heading';
import { FocusTrapDirective } from '../focus-trap/focus-trap.directive';

const COMPONENTS = [SliderComponent, FocusTrapDirective];

@NgModule({
	imports: [
		EdAssistUIIconModule,
		CommonModule,
		EdAssistUIButtonModule,
		EdAssistUIHeadingModule
	],
	exports: COMPONENTS,
	declarations: COMPONENTS
})
class EdAssistUISliderModule {}

export { EdAssistUISliderModule, SliderComponent, SliderDirection };
